export function showModalEpc(epcCurrent: number, epcPotential: number) {
  const modalEpc = document.querySelector('#modal-epc-generation') as HTMLDialogElement
  if (modalEpc) {
    modalEpc.showModal()

    // Dispatch event to Vue component
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('update-epc-values', {
        detail: { current: epcCurrent, potential: epcPotential },
      }))
    }, 100)
  }
}

export async function uploadEpcToMediaServer(
  propertyId: number,
  imageBase64: string,
  currentEpc: number,
  potentialEpc: number,
) {
  const url = '/PropertyShared/GenerateEpc'

  const payload = JSON.stringify({
    PropertyId: propertyId,
    ImageBase64: imageBase64,
    CurrentEpc: currentEpc,
    PotentialEpc: potentialEpc,
  })

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
    })

    const data = await response.json()

    if (!response.ok || !data.Success)
      throw new Error(data?.Message || 'Failed to upload EPC')

    return data
  }
  catch (error) {
    throw new Error(`Error uploading EPC: ${error instanceof Error ? error.message : String(error)}`)
  }
}

declare global {
  interface Window {
    showModalEpc: typeof showModalEpc
    uploadEpcToMediaServer: typeof uploadEpcToMediaServer
  }
}

// Attach functions to window for global usage
window.showModalEpc = showModalEpc
window.uploadEpcToMediaServer = uploadEpcToMediaServer
